import React, { useState } from "react"
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel,
    FormGroup
} from "@mui/material"
import { makeStyles } from "@mui/styles"

import { productTypeAllOption } from "../../utils/dispatchUtils"

const useStyles = makeStyles({
    productTypes: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        marginTop: 16
    }
})

// product types (kfcName) hidden by default on the packaging cover page
export const DEFAULT_HEAD_PAGE_EXCLUDED_PRODUCT_TYPES = ["FRUIT", "BREAD", "ANTI_WASTE_BASKET"]

// mounted only while open, so the default selection is restored on each download
const HeadPageProductTypesModal = ({ productTypeOptions = [], onClose, onConfirm }) => {
    const classes = useStyles()
    // the store list starts with a "Tous" option, meaningless here
    const productTypes = productTypeOptions.filter(productType => productType.value !== productTypeAllOption.value)
    const [excludedProductTypes, setExcludedProductTypes] = useState(DEFAULT_HEAD_PAGE_EXCLUDED_PRODUCT_TYPES)

    const toggleProductType = (value) => {
        setExcludedProductTypes(prev => prev.includes(value)
            ? prev.filter(productType => productType !== value)
            : [...prev, value]
        )
    }

    const handleConfirm = () => {
        // only send product types that still exist
        const values = productTypes.map(productType => productType.value)
        onConfirm(excludedProductTypes.filter(productType => values.includes(productType)))
    }

    return (
        <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Page de garde</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Souhaitez-vous masquer certaines catégories de plats ?
                </DialogContentText>
                <FormGroup className={classes.productTypes}>
                    {productTypes.map(productType => (
                        <FormControlLabel
                            key={productType.value}
                            label={productType.label}
                            control={
                                <Checkbox
                                    checked={excludedProductTypes.includes(productType.value)}
                                    onChange={() => toggleProductType(productType.value)}
                                />
                            }
                        />
                    ))}
                </FormGroup>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
                <Button variant="contained" onClick={handleConfirm}>Télécharger</Button>
            </DialogActions>
        </Dialog>
    )
}

export default HeadPageProductTypesModal
